import { makeStyles } from '@mui/styles';
import { AlertSchema, PhenologicalStateWithId } from '../../../requests/api/apiTypes';
import { Interval } from '../../../types';

export const useStyles = makeStyles(() => ({
  dialogContent: {
    minWidth: '500px',
  },
  formContainer: {
    display: 'flex',
    marginTop: '16px',
    flexDirection: 'column',
    gap: '16px',
  },
  limitContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginTop: '8px',
  },
}));

export interface Limit {
  name: string;
  value: number;
  top: boolean;
}

export interface CultivationCycle {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  phenologicalStates?: PhenologicalStateWithId[];
}

export interface User {
  id: string;
  name: string;
  email: string;
  phoneNumber?: string;
}

export enum AlertModalMode {
  CREATE = 'create',
  VIEW = 'view',
  UPDATE = 'update',
}

export interface AlertModalProps {
  interval: Interval | null;
  open: boolean;
  onClose: () => void;
  sectorId: string;
  measurements: Array<{
    id: string;
    name: string;
  }>;
  chartName: string;
  mode?: AlertModalMode;
  alertData?: AlertSchema;
  onAlertUpdated?: () => void;
}

export const MAX_FREQUENCY_OPTIONS = [
  { value: '30', label: '30 minutos' },
  { value: '60', label: '1 hora' },
  { value: '480', label: '8 horas' },
  { value: '720', label: '12 horas' },
  { value: '1440', label: '24 horas' },
];

export const TIME_OUT_RANGE_OPTIONS = [
  { value: '5', label: '5 minutos' },
  { value: '10', label: '10 minutos' },
  { value: '15', label: '15 minutos' },
  { value: '30', label: '30 minutos' },
  { value: '45', label: '45 minutos' },
  { value: '60', label: '1 hora' },
  { value: '120', label: '2 horas' },
  { value: '180', label: '3 horas' },
  { value: '360', label: '6 horas' },
];

export const REVIEW_SCHEDULE_OPTIONS = [
  { value: '10', label: 'Cada 10 minutos' },
  { value: '20', label: 'Cada 20 minutos' },
  { value: '30', label: 'Cada 30 minutos' },
  { value: '40', label: 'Cada 40 minutos' },
  { value: '50', label: 'Cada 50 minutos' },
  { value: '60', label: 'Cada 60 minutos' },
  { value: '80', label: 'Cada 80 minutos' },
  { value: '100', label: 'Cada 100 minutos' },
  { value: '120', label: 'Cada 120 minutos' },
  { value: '180', label: 'Cada 180 minutos' },
  { value: '240', label: 'Cada 240 minutos' },
  { value: '300', label: 'Cada 300 minutos' },
  { value: '360', label: 'Cada 360 minutos' },
];
